import { useEffect, useState } from "react";

export enum MediaDeviceType {
  AUDIO_INPUT = "audioinput",
  AUDIO_OUTPUT = "audiooutput",
  VIDEO_INPUT = "videoinput",
}

export const useMediaDevice = (deviceType: MediaDeviceType) => {
  const [hasDevice, setHasDevice] = useState<boolean | null>(null);

  useEffect(() => {
    const checkDevice = async () => {
      try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const hasDevice = devices.some((device) => device.kind === deviceType);

        setHasDevice(hasDevice);
      } catch (error) {
        console.error("Error checking device:", error);
        setHasDevice(false);
      }
    };

    checkDevice();
  }, [deviceType]);

  const isPermissionAccepted = async () => {
    try {
      await navigator.mediaDevices.getUserMedia({
        video: deviceType === MediaDeviceType.VIDEO_INPUT,
        audio: deviceType === MediaDeviceType.AUDIO_INPUT,
      });
      return true;
    } catch (error) {
      console.error("Failed to get media device:", error);
      return false;
    }
  };

  return { hasDevice, isPermissionAccepted };
};
